import OutlierDetectorEditDto from './OutlierDetectorEditDto';

export class IsolationForestModelEditDto extends OutlierDetectorEditDto {
	constructor() {
		super();
		/** @type {number} */
		this.n_estimators = null;
		/** @type {number} */
		this.contamination = null;
	}

	/**
	 * @typedef {Object} _IsolationForestModelEditDtoProps
	 * @property {number} n_estimators
	 * @property {number} contamination
	 *
	 * @typedef {import("./OutlierDetectorEditDto").OutlierDetectorEditDtoProps & _IsolationForestModelEditDtoProps} IsolationForestModelEditDtoProps
	 */
	/**
	 *
	 * @param {IsolationForestModelEditDtoProps} props
	 * @returns {IsolationForestModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.n_estimators = props.n_estimators;
		this.contamination = props.contamination;
		return this;
	}
}

export default IsolationForestModelEditDto;